/* global localStorage, */

export const AsyncStorage = {
  getAllKeys: async () => Object.keys(localStorage),
  getItem: async (key) => localStorage.getItem(key),
  setItem: async (key, value) => localStorage.setItem(key, value),
  removeItem: async (key) => localStorage.removeItem(key),
};
